module.exports = __webpack_public_path__ + "img/APPR.d85bd21b.svg";